import { useGlobalState } from "AppStore";
import { Dashboard, Page } from "model/Datatypes";
import React from "react";

type Props = {
  currentPage: Page;
  dashboard: Dashboard;
};

const SiteInformation = ({ dashboard }: Props) => {
  const { type } = useGlobalState();
  return (
    <div
      className={` ${
        type === "TALL" ? "lg:px-12 lg:mb-8 " : "2xl:px-20 hidden 2xl:block"
      } px-4 w-full bottom-2 mb-2`}
    >
      <div className="text-white text-2xl 2xl:text-8xl py-1 mb-4 font-bold text-shadow border-b border-white hidden 2xl:block">
        {dashboard?.siteName}
      </div>
      <div className="text-white text-sm 2xl:text-4xl h-1/6 font-normal 2xl:px-1">
        {dashboard?.siteDescription}
      </div>
    </div>
  );
};

export default SiteInformation;
